import { Button, Descriptions, Form, Input, Modal } from 'antd';
import React, { useEffect, useState } from 'react';
import { useIntl } from 'react-intl';
import IntlMessages from '../../components/IntlMessage';
import orderApi from '../../api/order';
import { MinusCircleOutlined, PlusOutlined } from '@ant-design/icons';
import _ from 'lodash';

const formItemLayout = {
  labelCol: {
    xs: {
      span: 24,
    },
    sm: {
      span: 4,
    },
  },
  wrapperCol: {
    xs: {
      span: 24,
    },
    sm: {
      span: 20,
    },
  },
};
const formItemLayoutWithOutLabel = {
  wrapperCol: {
    xs: {
      span: 24,
      offset: 0,
    },
    sm: {
      span: 20,
      offset: 4,
    },
  },
};
const FormPdf = ({ open, onClose, currentData = {}, onReload }) => {
  const intl = useIntl();
  const handleCancel = () => {
    onClose();
  };
  const handleSubmit = () => {};
  const [loadingpdf, setLoadingpdf] = useState(false);
  const handleCreatePdf = async (record) => {
    setLoadingpdf(true);
    await orderApi
      .createPDF(record.id)
      .then((data) => {
        setLoadingpdf(false);
        onReload();
        // window.open(data.data, '_blank');
      })
      .catch((error) => {
        console.error(error);
        setLoadingpdf(false);
        Modal.error({
          title: error,
          okText: intl.formatMessage({ id: 'global.close' }),
        });
      })
      .finally(function() {
        setLoadingpdf(false);
      });
    setLoadingpdf(false);
  };
  const [loading, setLoading] = useState(false);
  const onFinish = async (values) => {
    // console.log('Received values of form:', values);
    const data = { ...values };
    data.order_id = currentData.id;
    await orderApi
      .getSendEmail(data)
      .then(() => {
        setLoading(false);
        handleCancel();
        Modal.success({
          title: `Send email to ${data.emails?.join(', ')} successfully`,
        });
      })
      .catch((error) => {
        console.error(error);
        Modal.error({
          title: error.data.message,
          okText: intl.formatMessage({ id: 'global.close' }),
        });
        setLoading(false);
      });
  };
  const [form] = Form.useForm();

  useEffect(() => {
    // const contactInfo = JSON.parse(currentData?.contact_info);
    // const emailArray = [contactInfo?.email];
    // if (currentData?.customer?.email) {
    //   emailArray.push(currentData?.customer?.email);
    // }

    // const uniqueEmailArray = _.uniq(emailArray);

    // form.setFieldsValue({
    //   emails: uniqueEmailArray || [],
    // });

    form.setFieldsValue({
      emails: currentData?.contact_info
        ? [JSON.parse(currentData?.contact_info)?.email]
        : [currentData?.customer?.email] || [],
    });
  }, []);

  return (
    <>
      <Modal
        // title={
        //     <IntlMessages id="global.add" />
        // }
        open={true}
        width={'60%'}
        destroyOnClose={true}
        onCancel={handleCancel}
        onOk={handleSubmit}
        footer={[
          <Button key="back" type="default" onClick={handleCancel}>
            {<IntlMessages id="global.cancel" />}
          </Button>,
          // <Button
          //     key="submit"
          //     type="primary"
          //     htmlType="submit"
          //     // loading={loading}
          //     onClick={handleSubmit}
          // >
          //     {<IntlMessages id="global.save" />}
          // </Button>,
        ]}
      >
        <Descriptions title="Voucher customer" bordered>
          <Descriptions.Item
            label="Download pdf"
            span={3}
            labelStyle={{ width: '30%' }}
          >
            <Button
              type="primary"
              // size="small"
              // style={{ marginTop: '5px', fontSize: '16px' }}
              onClick={() => handleCreatePdf(currentData)}
              loading={loadingpdf}
            >
              <IntlMessages id="global.voucher" />
            </Button>
          </Descriptions.Item>
          <Descriptions.Item
            label={`Send email to ${
              currentData?.customer?.fullname
                ? currentData?.customer?.fullname
                : currentData?.customer?.firstname +
                  ' ' +
                  currentData?.customer?.lastname
            }`}
          >
            <Form
              form={form}
              name="dynamic_form_item"
              {...formItemLayoutWithOutLabel}
              onFinish={onFinish}
              style={{
                maxWidth: 600,
              }}
            >
              <Form.List
                name="emails"
                rules={[
                  {
                    validator: async (_, names) => {
                      if (!names || names.length < 1) {
                        throw new Error('At least 1 email');
                      }
                    },
                  },
                ]}
              >
                {(fields, { add, remove }, { errors }) => (
                  <>
                    {fields.map((field, index) => (
                      <Form.Item
                        {...(index === 0
                          ? formItemLayout
                          : formItemLayoutWithOutLabel)}
                        label={index === 0 ? 'Email' : ''}
                        required={false}
                        key={field.key}
                        labelAlign="left"
                      >
                        <Form.Item
                          {...field}
                          validateTrigger={['onChange', 'onBlur']}
                          rules={[
                            {
                              required: true,
                              message: (
                                <IntlMessages id="global.input_email_or_delete" />
                              ),
                              whitespace: true,
                            },
                            {
                              type: 'email',
                            },
                          ]}
                          type="email"
                          noStyle
                        >
                          <Input
                            placeholder="Enter your email"
                            style={{
                              width: '60%',
                            }}
                          />
                        </Form.Item>
                        {fields.length > 1 ? (
                          <MinusCircleOutlined
                            className="dynamic-delete-button"
                            onClick={() => remove(field.name)}
                          />
                        ) : null}
                      </Form.Item>
                    ))}
                    <Form.Item>
                      <Button
                        type="dashed"
                        onClick={() => add()}
                        style={{
                          width: '60%',
                        }}
                        icon={<PlusOutlined />}
                      >
                        Add email
                      </Button>
                      <Form.ErrorList errors={errors} />
                    </Form.Item>
                  </>
                )}
              </Form.List>
              <Form.Item>
                <Button type="primary" htmlType="submit" loading={loading}>
                  Send
                </Button>
              </Form.Item>
            </Form>
          </Descriptions.Item>
        </Descriptions>
      </Modal>
    </>
  );
};

export default FormPdf;
